import _ from 'lodash'
import * as React from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import SetUpFilterList from './SetUpFilterList'
import { MENUITEMS } from '../../utils'
import FooterButtons from './FooterButtons'

const AdvancedSearch = ({ open, advancedSearch, windowWidth }) => {
  const [enableFilterButton, setEnableFilterButton] = React.useState(false)
  const { filtersList } = useSelector(state => state.filterSearch)
  const isAuth = useSelector(state => state.login.authenticated?.auth)

  const filterContairne = (obj, index) => {
    const OPTIONSLIST = isAuth
      ? MENUITEMS
      : _.filter(MENUITEMS, obj => obj.value !== 'suggestions')
    let selected = _.find(OPTIONSLIST, ['value', obj.type])
    const specieTableList = ['pseudonym', 'specie', 'family']
    let typelist = _.map(filtersList, 'type')
    const isATypeSpecieID = _.map(typelist, value =>
      _.some(specieTableList, o => o === value)
    )

    if (_.some(isATypeSpecieID, Boolean)) typelist = _.union(typelist, specieTableList)
    if (isATypeSpecieID[index])
      selected = _.filter(OPTIONSLIST, obj => _.includes(specieTableList, obj.value))

    const filtersOpts = _.filter(OPTIONSLIST, obj => !_.includes(typelist, obj.value))
    const options = Boolean(selected) ? _.concat(selected, filtersOpts) : filtersOpts
    const props = {
      open,
      idx: index,
      windowWidth,
      nroOptsTypes: isAuth ? 9 : 8,
      options,
      advancedSearch,
      setEnableFilterButton,
      lengthList: filtersList.length,
      ...obj,
    }
    return (
      <SetUpFilterList id={`box-filter-${index}`} key={`block-${obj.type}`} {...props} />
    )
  }

  const propsFooterBT = {
    filtersList,
    advancedSearch,
    windowWidth,
    enableFilterButton,
    setEnableFilterButton,
  }

  return (
    <Box sx={{ width: '100%', maxWidth: 'calc(100vw - 95px)' }}>
      {_.map(filtersList, filterContairne)}
      <FooterButtons {...propsFooterBT} />
    </Box>
  )
}
export default AdvancedSearch
